// unix : PUBLIC_URL=http://54.180.183.35:5200 yarn build
// unix : PUBLIC_URL=https://aleo.walletapp.biz/react_test yarn build

export const BASE_URL = 'http://54.180.183.35:5200';
//export const BASE_URL = null;
export const DO_MAIN = 'ALEO';